import { NotificationBar, TYPE_ORBITAL } from '@eventbrite/eds-notification';
import { gettext } from '@eventbrite/i18n';
import React, { FunctionComponent } from 'react';
import {
    getGoogleChromeUrlForCheckout,
    shareCheckoutUrl,
    shouldPerformTablessCheckout,
} from '../utils/browser';

export const LimitedPaymentMethodsInMobileNotification: FunctionComponent = () => {
    if (!shouldPerformTablessCheckout()) {
        return null;
    }

    const url = new URL(window.location.href);
    url.searchParams.delete('profile');

    return (
        <NotificationBar type={TYPE_ORBITAL} hasCloseButton={false}>
            <span
                onClick={(event) => {
                    const target = event.target as HTMLElement;
                    const isClickingLink =
                        target.nodeName.toLowerCase() === 'a';

                    if (!isClickingLink) {
                        return;
                    }

                    shareCheckoutUrl();
                }}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                    __html: gettext(
                        'You can pay with a credit card and PayPal in the app. To pay with another method, <a href="%(openInBrowserUrl)s">open Eventbrite in your browser</a>.',
                        {
                            openInBrowserUrl: getGoogleChromeUrlForCheckout(),
                        },
                    ).toString(),
                }}
            />
        </NotificationBar>
    );
};
